var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-app-search",
      attrs: { id: "form-search-popover" }
    },
    [
      _c(
        "div",
        {
          staticClass: "studio-page-header",
          class: { "studio-page-header-long": !_vm.is_sidebar_minimized },
          staticStyle: {
            "padding-bottom": "0 !important",
            "padding-top": "15px !important",
            height: "110px"
          }
        },
        [
          _c("div", { staticClass: "d-flex apps" }, [
            _c("img", {
              staticClass: "back-to-list-apps",
              attrs: { src: require("@/assets/icon/arrow-left.svg") },
              on: {
                click: function($event) {
                  _vm.$router.push("/access-application")
                }
              }
            }),
            _vm._v(" "),
            _vm.apps_detail
              ? _c("img", {
                  staticClass: "m__r--5",
                  attrs: { src: _vm.apps_detail.icon, width: "25" }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "title-apps" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.apps_detail ? _vm.apps_detail.name : "") +
                  "\n      "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex m__t--39" }, [
            _c(
              "div",
              {
                staticClass: "tab-experience-manager m__r--35",
                class: {
                  "tab-experience-manager-active":
                    _vm.tabSelected === "privileges"
                },
                on: {
                  click: function($event) {
                    _vm.tabSelected = "privileges"
                  }
                }
              },
              [_vm._v("\n        PRIVILEGES\n      ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "tab-experience-manager m__r--35",
                class: {
                  "tab-experience-manager-active":
                    _vm.tabSelected === "security"
                },
                on: {
                  click: function($event) {
                    _vm.tabSelected = "security"
                  }
                }
              },
              [_vm._v("\n        SECURITY\n      ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "tab-experience-manager",
                class: {
                  "tab-experience-manager-active":
                    _vm.tabSelected === "maintenance"
                },
                on: {
                  click: function($event) {
                    _vm.tabSelected = "maintenance"
                  }
                }
              },
              [_vm._v("\n        MAINTENANCE\n      ")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.tabSelected === "privileges"
        ? _c(
            "div",
            { staticClass: "studio-page-content" },
            [_c("jAccessApplicationTabPrivilege")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tabSelected === "security"
        ? _c(
            "div",
            { staticClass: "studio-page-content" },
            [_c("jAccessApplicationTabSecurity")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tabSelected === "maintenance"
        ? _c(
            "div",
            { staticClass: "studio-page-content" },
            [_c("jAccessApplicationTabMaintenance")],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-83c34dd8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83c34dd8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/access/jAccessApplicationDetail.vue
// module id = null
// module chunks = 